import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";
// import { Element } from "chart.js";
// Connects to data-controller="product-item-select-field"
export default class extends Controller {
  static targets = ["fieldParent"];
  static values = { url: String };

  fetchProductSizeAndVariants(event) {
    const productId = event.target.value;

    if (productId) {
      const url = this.urlValue.replace("REPLACE_WITH_PRODUCT_ID", productId);
      get(url)
        .then((response) => {
          if (response.ok) {
            console.log("Fetch successful");
          } else {
            alert("Try again");
          }
        })
        .catch(() => {
          alert("Try again");
        });
    } else {
      this.element.reset();

      Array.from(this.fieldParentTarget.querySelectorAll("select")).forEach((element) => {
        console.log(element);
        element.disabled = true;
      });
    }
  }
}
